import {
  toValue,
  type MaybeRefOrGetter,
  type ComputedRef,
  computed,
} from "vue";
import { getQrUrl } from "@/data/constants";

export type PrintValuesReturn = {
  barcode: ComputedRef<string | null>,
  url: ComputedRef<string | null>,
};

export function useBarcodeValues(
  id: MaybeRefOrGetter<number | null | undefined>,
): PrintValuesReturn {
  const barcode = computed(() => {
    const currentId = toValue(id);
    return typeof currentId !== "number"
      ? null
      : "AMS." +
          (
            String(currentId)
              // pad with min 8 (`2 * 4`) zeros, or more, in steps of 4.
              .padStart(
                // eslint-disable-next-line prettier/prettier
                Math.max(
                  2,
                  Math.ceil(String(currentId).length / 4)
                ) * 4,
                // eslint-disable-next-line prettier/prettier
                "0",
              )
              // reverse string so any excess digits up in the front after the regex split (if padStart ever ends up failing)
              .split("")
              .reverse()
              .join("")
              // split in tuples of 4 digits
              // fallback to "AMS.????.????" if we have no match (should never happen, just to satisfy the linter).
              .match(/.{4}|.{1,3}/g) ?? ["????", "????"]
          )
            // add a dot between the tuples.
            .join(".")
            // move it back into the correct order
            .split("")
            .reverse()
            // .join the tuples to be the final string.
            // eslint-disable-next-line prettier/prettier
            .join("")
    ;
  });
  // eslint-disable-next-line prettier/prettier
  const url = computed(
    () => (
      /* eslint-disable-line prettier/prettier *//* eslint-disable-next-line prettier/prettier */
      barcode.value === null
      ? null
      : getQrUrl(barcode.value)
    )
  );
  return {
    barcode,
    url,
  };
}
